<template>
	<v-row>
		<v-col cols="12" md="4">

			<v-card tile>

				<v-card-title class="headline">Случаи коронавируса</v-card-title>

				<v-card-subtitle class="display-2">{{ allCases }} чел.</v-card-subtitle>

			</v-card>

		</v-col>

		<v-col cols="12" md="4">


			<v-card tile>

				<v-card-title class="headline">Летальных исходов</v-card-title>

				<v-card-subtitle class="display-2">{{ allDeaths }} чел.</v-card-subtitle>

			</v-card>

		</v-col>

		<v-col cols="12" md="4">

			<v-card tile>

				<v-card-title class="headline">Выздоровевших</v-card-title>

				<v-card-subtitle class="display-2">{{ allRecovered }} чел.</v-card-subtitle>

			</v-card>

		</v-col>
	</v-row>
</template>

<script>

	const axios = require('axios');
	
	export default {
		data: function() {
			return {
				allCases: "",
				allDeaths: "",
				allRecovered: "",
			}
		},

		mounted() {
			this.getWorldStatsCovid() 
		},

		methods: {
			getWorldStatsCovid() {
				var self = this;
				axios.get('./covid/world_stats_today.json')
					.then(function (response) {
						self.allCases = response.data.world_stats_today[0].CoronavirusCases;
						self.allDeaths = response.data.world_stats_today[0].Deaths;
						self.allRecovered = response.data.world_stats_today[0].Recovered;
					})
					.catch(function (error) {
						// handle error
						console.log(error);
					})
					.finally(function () {
						// always executed
					});
			},
		}
	}
</script>